module.exports = __webpack_public_path__ + "static/media/editor-story-view.21f252cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/editor-story-view.jpg
// module id = 1004
// module chunks = 4